export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4846.100d77a0.jpg";